import baseUrlUtil from 'util/base-url-util';

import type { AxiosError } from 'axios';
import axios from 'axios';
import config from 'config/config';
import posthog from 'posthog-js';

declare const VERSION: string;

const isBlacklisted = async ({ fingerprint, ip }: { fingerprint: string; ip: string }): Promise<boolean> => {
  try {
    const apiBaseUrl = config.publicApi.enabled ? `${config.publicApi.url}` : `${config.api.url}`;
    const response = await axios.get<{ data: boolean }>(`${apiBaseUrl}/api/ip-black-list/`, {
      params: { fingerprint, ip, store: baseUrlUtil.getBaseUrl() }
    });
    return response.data?.data || false;
  } catch (e) {
    const error = e as AxiosError;
    posthog?.capture('isBlacklistedFailed', { error: error.toJSON(), version: VERSION });
    console.error(`file to get blacklisted date ${(e as AxiosError).message}`);
    return false;
  }
};
export default isBlacklisted;
